<template>
  <div class="container">
    <GroupsScoreboard />
    <div class="mb-5"></div>

    <RouterButton to="Achievements" label="Go to Achievements" icon="award" />

    <div class="mb-5"></div>

    <div class="row justify-content-center">
      <div class="col-sm-12 col-md-12 col-lg-10 col-xl-9 col-xxl-8">
        <AchievementFeed />
      </div>
    </div>
  </div>
</template>

<script>
import GroupsScoreboard from "@/components/activity/GroupsScoreboard.vue";
import AchievementFeed from "@/components/activity/AchievementFeed.vue";
import RouterButton from "@/components/activity/RouterButton.vue";

export default {
  name: "HomeView",
  components: {
    GroupsScoreboard,
    AchievementFeed,
    RouterButton
  }
};
</script>
